import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Clock } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const H = Array.from({ length: 25 }, (_, i) => i);
const lbl = (h) => (h === 0 || h === 24 ? "12 AM" : h === 12 ? "12 PM" : h < 12 ? `${h} AM` : `${h - 12} PM`);

export const ServiceHoursBar = () => {
  const [h, setH] = useState(null);
  useEffect(() => { api.get("/admin/service-hours").then((r) => setH(r.data)).catch(() => {}); }, []);
  if (!h) return null;
  const save = (k, v) => api.put("/admin/service-hours", { ...h, [k]: Number(v) }).then((r) => { setH(r.data); toast.success("Offer hours saved"); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-[#E3E6DD] bg-white p-3 text-sm" data-testid="service-hours-bar">
      <Clock className="h-4 w-4 text-[#2E9E6B]" /><b className="text-[#0D3B2B]">Pickup offers go out</b>
      <select value={h.open} onChange={(e) => save("open", e.target.value)} className="h-9 rounded-full border border-[#D6DBD2] px-2 text-xs font-bold" data-testid="service-hours-open">{H.slice(0, 24).map((x) => <option key={x} value={x}>{lbl(x)}</option>)}</select>
      to
      <select value={h.close} onChange={(e) => save("close", e.target.value)} className="h-9 rounded-full border border-[#D6DBD2] px-2 text-xs font-bold" data-testid="service-hours-close">{H.slice(1).map((x) => <option key={x} value={x}>{lbl(x)}</option>)}</select>
      <span className={`ml-auto rounded-full px-3 py-1 text-xs font-bold ${h.now_open ? "bg-[#E3F4EA] text-[#1F7A50]" : "bg-[#EEF5FF] text-[#1E3A8A]"}`} data-testid="service-hours-state">
        {h.now_open ? "Open now: offers are live" : "Closed now: new bookings are queued until opening"}</span>
    </div>
  );
};
